<template>
  <div class="global-content">
    <div class="info-box">
      <a-config-provider :locale="zhCN">
        <a-table
          :dataSource="data"
          :columns="columns"
          :pagination="pagination"
          :bordered="bordered"
          rowKey="enterpriseId"
        >
          <div
            slot="filterDropdown"
            slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }"
            style="padding: 8px"
          >
            <a-input
              v-ant-ref="(c) => (searchInput = c)"
              :placeholder="`Search ${column.dataIndex}`"
              :value="selectedKeys[0]"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
              style="width: 188px; margin-bottom: 8px; display: block"
            />
            <a-button
              type="primary"
              @click="() => handleSearch(selectedKeys, confirm)"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              >Search
            </a-button>
            <a-button
              @click="() => handleReset(clearFilters)"
              size="small"
              style="width: 90px"
              >Reset
            </a-button>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template slot="customRender" slot-scope="text">
            <span v-if="searchText">
              <template
                v-for="(fragment, i) in text
                  .toString()
                  .split(
                    new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                  )"
              >
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                  >{{ fragment }}</mark
                >
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <template v-else>{{ text }} </template>
          </template>
          <template slot="operate" slot-scope="text, record">
            <a-button
              type="primary"
              icon="edit"
              @click="
                updateInfo(
                  record.enterpriseId,
                  record.fullName,
                  record.creditCode
                )
              "
              :size="buttonSize"
              >编辑</a-button
            >
            <a-button
              type="danger"
              icon="delete"
              @click="deleteInfo(record.enterpriseId)"
              class="my-btn"
              :size="buttonSize"
              >删除</a-button
            >
          </template>
        </a-table>
      </a-config-provider>
    </div>
    <a-modal
      ref="modal"
      title="编辑信息"
      v-model="visible"
      @ok="handleOk"
      okText="确定"
      cancelText="取消"
      :maskClosable="maskClosable"
    >
      <a-form :form="form">
        <a-form-item
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 13 }"
          label="企业名称"
        >
          <a-input
            ref="enterpriseName"
            v-decorator="[
              'enterpriseName',
              {
                rules: [
                  { required: true, message: '请输入企业名称' },
                  {
                    pattern: '^[\u4E00-\u9FA5A-Za-z0-9]+$',
                    message: '请输入中文,英文,数字',
                  },
                  { min: 1, max: 25, message: '最多输入25位' },
                ],
              },
            ]"
            autocomplete="off"
          />
        </a-form-item>
        <!-- <a-form-item :label-col="{span:8}" :wrapper-col="{span:13}" label="统一社会信用代码">
          <a-input ref="enterpriseCode"
                   v-decorator="['enterpriseCode',{ rules: [{ required: false, message: '请输入统一社会信用代码' },{ pattern: '^[A-Za-z0-9]{18}$', message: '请输入数字和字母的18位代码组合'}] },]" autocomplete="off"/>
        </a-form-item> -->
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN"; // 汉化

import { apiListPC } from "@/api";
import ajax from "@/api/ajax";

export default {
  name: "Info",
  data() {
    return {
      enterpriseId: "",
      visible: false,
      maskClosable: false, //点击遮罩层是否关闭对话框
      form: this.$form.createForm(this),
      bordered: true,
      zhCN,
      buttonSize: "small",
      data: [],
      searchText: "",
      searchInput: null,
      pageNo: 1,
      pageSize: 10,
      pagination: {
        showQuickJumper: true, //是否可以快速跳转至某页
        defaultPageSize: 10, //默认每页条数
        pageSizeOptions: ["10", "20", "50"],
        showSizeChanger: true,
        current: 1,
        onShowSizeChange: (current, pageSize) =>
          this.ChangePageSize(current, pageSize), // 改变每页数量时更新显示
        onChange: (page, pageSize) => this.changePage(page, pageSize), //点击页码事件
        total: 0,
        showTotal: showTotalFunc,
      },
      columns: [
        {
          title: "企业名称",
          dataIndex: "fullName",
          key: "name",
          scopedSlots: {
            // filterDropdown: 'filterDropdown',
            // filterIcon: 'filterIcon',
            customRender: "customRender",
          },
          onFilter: (value, record) =>
            record.fullName.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        // {
        //   title: "统一社会信用代码",
        //   dataIndex: "creditCode",
        //   key: "code",
        //   scopedSlots: {
        //     // filterDropdown: 'filterDropdown',
        //     // filterIcon: 'filterIcon',
        //     customRender: "customRender",
        //   },
        //   onFilter: (value, record) =>
        //     record.creditCode.toLowerCase().includes(value.toLowerCase()),
        //   onFilterDropdownVisibleChange: (visible) => {
        //     if (visible) {
        //       setTimeout(() => {
        //         this.searchInput.focus();
        //       });
        //     }
        //   },
        // },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
          scopedSlots: {
            customRender: "operate",
          },
        },
      ],
    };
  },
  beforeMount() {
    let formData = new FormData();
    formData.append("pageNo", this.pageNo);
    formData.append("pageSize", this.pageSize);
    getRecordListPge(this, formData);
  },
  methods: {
    ChangePageSize(current, pageSize) {
      this.pageSize = pageSize;
      let formData = new FormData();
      formData.append("pageNo", 1);
      formData.append("pageSize", pageSize);
      getRecordListPge(this, formData);
    },
    changePage(page, pageSize) {
      this.searchData(page, pageSize);
    },
    searchData(page, pageSize) {
      let that = this;
      //记录当前的页数
      that.pageNo = page;
      let formData = new FormData();
      formData.append("pageNo", page);
      formData.append("pageSize", pageSize);
      getRecordListPge(that, formData);
    },
    handleSearch(selectedKeys, confirm) {
      confirm();
      this.searchText = selectedKeys[0];
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },

    updateInfo(id, name, code) {
      this.visible = true;
      this.enterpriseId = id;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          enterpriseName: name,
          enterpriseCode: code,
        });
      });
    },

    deleteInfo(id) {
      let that = this;
      that.$confirm({
        content: "确认删除此条信息吗",
        title: "提示",
        okText: "确定",
        cancelText: "取消",
        type: "error",
        onOk() {
          that.bus.$emit("loading", true);
          let res = ajax(`${apiListPC.delCom}?enterpriseId=${id}`);
          res
            .then(function () {
              that.bus.$emit("loading", false);
              //删除成功以后 刷新table
              let formData = new FormData();
              formData.append("pageNo", that.pageNo);
              formData.append("pageSize", that.pageSize);
              getRecordListPge(that, formData);
            })
            .catch(function () {
              that.bus.$emit("loading", false);
            });
        },
      });
    },
    handleOk() {
      let that = this;
      // let checkName = new Promise((resolve) => {
      //   ajax(apiListPC.doubleCheck, sendData).then(res => {
      //     resolve(res.returnData)
      //   })
      // })
      that.form.validateFields((err) => {
        if (!err) {
          that.bus.$emit("loading", true);
          let sendData = {
            enterpriseId: that.enterpriseId,
            fullName: that.$refs.enterpriseName.value || "",
            creditCode: "",
          };
          ajax(apiListPC.doubleCheck, sendData)
            .then((res) => {
              if (res.same) {
                that.$message.error(res.msg);
              } else {
                let res = ajax(
                  `${apiListPC.editCom}?enterpriseId=${this.enterpriseId}`,
                  sendData,
                  "POST"
                );
                res
                  .then(function () {
                    that.bus.$emit("loading", false);
                    that.$message.success("编辑成功！");
                    //编辑成功以后 刷新table
                    let formData = new FormData();
                    formData.append("pageNo", that.pageNo);
                    formData.append("pageSize", that.pageSize);
                    getRecordListPge(that, formData);
                    that.visible = false;
                  })
                  .catch(function () {
                    that.bus.$emit("loading", false);
                    that.$message.error("编辑失败！");
                  });
              }
            })
            .catch(function () {
              that.bus.$emit("loading", false);
              that.$message.error("编辑失败！");
            });
        }
      });
    },
  },
};
function showTotalFunc(total, range) {
  return `总数据为${total}条，当前显示第${range[0]}条到第${range[1]}条`;
}

function getRecordListPge(that, formData) {
  that.bus.$emit("loading", true);
  const res = ajax(apiListPC.getcomList);
  res.then((data) => {
    that.bus.$emit("loading", false);
    that.data = data;
    that.pagination.total = data.length;
    that.pagination.current = that.pageNo;
  });
}
</script>

<style lang="less" type="text/less" scoped>
.global-content {
  padding-top: 1px;
  .info-box {
    margin: 20px;
    min-height: 760px;
    .my-btn {
      margin-left: 10px;
    }
  }
}
</style>
